export enum TRUST_BADGES_ORIENTATION {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export enum TRUST_BADGES_SIZE {
  SM = 'sm',
  MD = 'md',
}
